<template>
    <div>
        <ChatButton
            v-for="(conversation, index) in getChatButtons()"
            :key="conversation.id"
            :location-index="index"
            :conversation="conversation"
            :has-unread="hasUnread(conversation.id)"
            @conversation-click="setActiveConversation"
            @conversation-remove="removeConversation"
        />
        <SeeAllButton
            v-if="conversations.length > 3"
            :count="conversations.length - 3"
            :conversations="conversations.slice(3)"
            :has-unreads="!!unreadsList(conversations.slice(3)).length"
            :unreads="unreadsList(conversations.slice(3))"
            @conversation-click="setActiveConversation"
            @conversation-remove="removeConversation"
        />
    </div>
</template>

<script>
import ChatButton from './ChatButton';
import SeeAllButton from './SeeAllButton';
export default {
    name: 'ActiveChats',
    components: { SeeAllButton, ChatButton },
    props: {
        conversations: Array,
        unreads: {},
    },
    methods: {
        getChatButtons() {
            return this.conversations.slice(0, 3);
        },
        setActiveConversation(value) {
            this.$emit('active-conversation', value);
        },
        removeConversation(value) {
            this.$emit('remove-conversation', value);
        },
        hasUnread(id) {
            const { unreads } = this;
            return !!(
                unreads &&
                unreads.length &&
                unreads.filter(item => item.lastMessage.conversation.id === id)
                    .length > 0
            );
        },
        unreadsList(conversations) {
            let unreads = [];
            for (let i = 0; i < conversations.length; i++) {
                if (this.hasUnread(conversations[i].id))
                    unreads.push(conversations[i].id);
            }
            return unreads;
        },
    },
};
</script>

<style scoped></style>
